export enum UserRole {
  PRIVATE = 'PRIVATE',
  DEALER = 'DEALER',
  ADMIN = 'ADMIN',
  SHOP = 'SHOP',
  USER = 'USER',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  SUSPENDED = 'SUSPENDED',
}

// Listing lifecycle/status values used on admin flows and search filters
export enum ListingStatus {
  TOKEN_VERIFICATION_PENDING = 'token_verification_pending',
  TOKEN_VERIFIED = 'token_verified',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  ACTIVE = 'active',
}

// Dealer approval statuses
export enum DealerApprovalStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum DealerPaymentStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

// Generic approve/reject action for admin decisions
export enum DecisionAction {
  APPROVE = 'approve',
  REJECT = 'reject',
}

// Recent activity types and statuses
export enum AdminActionType {
  VERIFY_TOKEN = 'VERIFY_TOKEN',
  APPROVE_TOKEN = 'APPROVE_TOKEN',
  REJECT_TOKEN = 'REJECT_TOKEN',
  APPROVE_LISTING = 'APPROVE_LISTING',
  REJECT_LISTING = 'REJECT_LISTING',
  NEW_SUBMISSION = 'NEW_SUBMISSION',
  TOKEN_VERIFIED = 'token_verified',
  LISTING_APPROVED = 'listing_approved',
  TOKEN_REJECTED = 'token_rejected',
  NEW_SUBMISSION_LOWER = 'new_submission',
}

export enum AdminActionStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}
